import { View } from "./View";

export interface IErrorOccuredViewProps {
  message?: string;
}

export const ErrorOccuredView = (props: IErrorOccuredViewProps) => {
  const { message = "An error occured...Please retry" } = props;

  return <View message={message} />;
};
